module.exports = __webpack_public_path__ + "img/ring_g_l_1_null@3x.7999e331.png";